import {Card, Separator} from 'platform/components';
import {Grid, HStack, Icon, Show, Text, ThemeIconKey, VStack} from 'platform/foundation';

import {isNil, isNotEmpty} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {MessageRequirementItem} from '../../../components/MessageRequirementItem/MessageRequirementItem';
import {MESSAGE_SENDING_RULES} from '../constants/MESSAGE_SENDING_RULES';

const WHEN_ICON: ThemeIconKey = 'action/schedule';

interface MessageSpecificRequirementsProps extends TestIdProps {
  customerMessageId: string;
}

export function MessageSpecificRequirements(props: MessageSpecificRequirementsProps) {
  const sendingRules = MESSAGE_SENDING_RULES[props.customerMessageId];

  if (isNil(sendingRules)) {
    return null;
  }

  return (
    <Card
      variant="inlineGrey"
      title={i18n.t('page.settings.scheduledMessages.messageRequirements.title')}
      data-testid={suffixTestId('messageRequirements', props)}
    >
      <VStack spacing={4}>
        <MessageRequirementItem
          icon={WHEN_ICON}
          title={i18n.t('page.settings.scheduledMessages.messageRequirements.whenLabel')}
          description={sendingRules.when}
          data-testid={suffixTestId('messageRequirements-when', props)}
        />

        <Separator spacing={0} />

        <Show when={isNotEmpty(sendingRules.requirements)}>
          <VStack spacing={4}>
            <Text size="small" color="secondary">
              {i18n.t('page.settings.scheduledMessages.messageRequirements.description')}
            </Text>
            <Grid columns={[1, 1, 2, 2]} spacing={4}>
              {sendingRules.requirements.map((requirement, index) => (
                <MessageRequirementItem
                  key={requirement.title}
                  icon={requirement.icon}
                  title={requirement.title}
                  description={requirement.description}
                  data-testid={suffixTestId(`messageRequirements-[${index}]`, props)}
                />
              ))}
            </Grid>
          </VStack>
        </Show>
        <Show when={!isNotEmpty(sendingRules.requirements)}>
          <HStack spacing={2} align="center">
            <Icon value="action/check_circle" size={4} color="severity.success" />
            <Text size="small" color="secondary">
              {i18n.t('page.settings.scheduledMessages.messageRequirements.sharedOnly')}
            </Text>
          </HStack>
        </Show>
      </VStack>
    </Card>
  );
}
